import { METRIC_FILTER_KEYS } from './board-filter-params';
export function normalizeSearchText(raw) {
    return raw
        .toLocaleLowerCase('ru')
        .replace(/ё/g, 'е')
        .replace(/\s+/g, ' ')
        .trim();
}
export function matchesSearch(item, query) {
    const q = normalizeSearchText(query);
    if (!q)
        return true;
    const hay = normalizeSearchText([
        item.agentDisplayName,
        item.phone ?? '',
        item.displayNumber,
        item.agencyName ?? '',
    ].join(' '));
    if (hay.includes(q))
        return true;
    const digitQuery = q.replace(/\D/g, '');
    if (digitQuery.length >= 4 &&
        /[\d]/.test(q) &&
        !/[^\d\s()+\-]/.test(q) &&
        (item.phone ?? '').replace(/\D/g, '').includes(digitQuery)) {
        return true;
    }
    return false;
}
function inRange(value, minRaw, maxRaw) {
    if (minRaw) {
        const min = Number(minRaw);
        if (Number.isFinite(min) && value < min)
            return false;
    }
    if (maxRaw) {
        const max = Number(maxRaw);
        if (Number.isFinite(max) && value > max)
            return false;
    }
    return true;
}
export function matchesRatingFilters(item, filters) {
    const agent = item.ratingAgent ?? 0;
    const engagement = item.ratingEngagement ?? 0;
    const external = item.ratingExternal ?? 0;
    return (inRange(agent, filters.ratingMin, filters.ratingMax) &&
        inRange(engagement, filters.engagementMin, filters.engagementMax) &&
        inRange(external, filters.externalMin, filters.externalMax));
}
export function matchesBoardFilters(item, filters, currentManagerId, options) {
    const applyStatus = options?.applyStatus ?? true;
    if (applyStatus && filters.status !== 'all') {
        const want = filters.status === 'active' ? 'ACTIVE' : 'CLOSED';
        if (item.status && item.status !== want)
            return false;
    }
    if (filters.mine) {
        if (!currentManagerId || item.responsibleManagerId !== currentManagerId) {
            return false;
        }
    }
    if (filters.responsible === 'none') {
        if (item.responsibleManagerId != null)
            return false;
    }
    else if (filters.responsible !== 'all') {
        if (item.responsibleManagerId !== filters.responsible)
            return false;
    }
    if (filters.agency === 'none') {
        if (item.agencyName?.trim())
            return false;
    }
    else if (filters.agency !== 'all') {
        if ((item.agencyName ?? '').trim() !== filters.agency)
            return false;
    }
    if (!matchesSearch(item, filters.q))
        return false;
    return matchesRatingFilters(item, filters);
}
export function compareBoardItems(a, b, sort) {
    if (sort === 'default')
        return 0;
    const [field, direction] = sort.split('-');
    const sign = direction === 'asc' ? 1 : -1;
    const valueOf = (item) => {
        if (field === 'age')
            return item.stageAgeMs ?? 0;
        if (field === 'rating')
            return item.ratingAgent ?? 0;
        if (field === 'engagement')
            return item.ratingEngagement ?? 0;
        if (field === 'external')
            return item.ratingExternal ?? 0;
        return 0;
    };
    return sign * (valueOf(a) - valueOf(b));
}
export function sortBoardItems(items, sort) {
    if (sort === 'default')
        return items;
    return [...items].sort((a, b) => compareBoardItems(a, b, sort));
}
const METRIC_FIELD = {
    notices: 'notices',
    leads: 'leads',
    meetings: 'meetings',
    bookings: 'bookings',
    deals: 'deals',
};
export function isPriorityCell(cell) {
    if (!cell)
        return true;
    return !cell.visited && cell.bookings === 0 && cell.notices === 0;
}
/** No У on selected project, У > 0 on another project of the same cycle. */
export function matchesOtherProjectNotices(cells, projectCode) {
    if (!projectCode)
        return false;
    const selected = cells.find((cell) => cell.projectCode === projectCode);
    if (!selected || selected.notices > 0)
        return false;
    return cells.some((cell) => cell.projectCode !== projectCode && cell.notices > 0);
}
export function matchesMatrixMetrics(cells, filters) {
    if (filters.priority) {
        if (filters.project) {
            const cell = cells.find((item) => item.projectCode === filters.project);
            if (!isPriorityCell(cell))
                return false;
        }
        else if (!cells.some((cell) => isPriorityCell(cell))) {
            return false;
        }
    }
    if (filters.otherProjectNotices) {
        if (!matchesOtherProjectNotices(cells, filters.project))
            return false;
    }
    const active = METRIC_FILTER_KEYS.filter((key) => filters.metrics[key] !== 'all');
    if (active.length === 0)
        return true;
    const considered = filters.metricScope === 'all' || !filters.project
        ? cells
        : cells.filter((cell) => cell.projectCode === filters.project);
    if (considered.length === 0)
        return false;
    return active.every((key) => {
        const field = METRIC_FIELD[key];
        const total = considered.reduce((sum, cell) => {
            const value = cell[field];
            return sum + (typeof value === 'number' ? value : 0);
        }, 0);
        return filters.metrics[key] === 'yes' ? total > 0 : total === 0;
    });
}
export function matchesMatrixRow(row, filters, currentManagerId) {
    if (!matchesBoardFilters(row, filters, currentManagerId, { applyStatus: false })) {
        return false;
    }
    return matchesMatrixMetrics(row.cells, filters);
}
